import React from "react";
import { Link } from "react-router-dom";
import "./PaymentSuccess.css"; // Styling file

const PaymentFeild = ({ Paymentdata }) => {
  return (
    <div
      className="payment-success-container"
      style={{ backgroundColor: " #ffd3d3" }}
    >
      <div className="success-card">
        <div className="checkmark" style={{ color: "red", fontSize: "48px" }}>
          ❌
        </div>
        <h1>Payment Feild!</h1>
        {/* <p>Please provide your payment information to complete the checkout.</p> */}
        {/* Optional: Order ID, Total, etc. */}
        <div className="order-info mt-5">
          <div className="orderBOXdetails">
            {Paymentdata && Paymentdata.payu_txnid && (
              <p>
                <strong>Transection ID :</strong> {Paymentdata.payu_txnid}
              </p>
            )}
            {Paymentdata && Paymentdata.order_id && (
              <p>
                <strong>Order ID :</strong> {Paymentdata.order_id}
              </p>
            )}
          </div>
          <div className="orderBOXdetails">
            {Paymentdata && Paymentdata.amount && (
              <p>
                <strong>Amount :</strong> {Paymentdata.amount}
              </p>
            )}
            {Paymentdata && Paymentdata.discountamount !== "0" && (
              <p>
                <strong>Discount : </strong> {Paymentdata.discountamount}
              </p>
            )}
          </div>
        </div>

        <Link to="/" className="btn-home">
          Go to Home
        </Link>
      </div>
    </div>
  );
};

export default PaymentFeild;
